export const environment = {
  production: false,

  api: {
    host: "google-oauth-api.staging.immergas.cordev.it",
    stage: "staging"
  },

  amplify: {
    region: 'eu-central-1',
    Auth: {
      userPoolId: 'eu-central-1_KttbfgZmj',
      userPoolClientId: '1nisdbd3u49ue8pteo25emdov6',
      cognitoDomain: 'smartech-plus-staging.auth.eu-central-1.amazoncognito.com'
    }
  }
}